<script setup>
import { useReportTimezone } from 'dashboard/composables/useReportTimezone';

// O recorte do dia sai do fuso da CONTA, nao do navegador. A linha existe para
// o numero ser auditavel: quem le sabe em que fuso o dia foi fechado.
const { reportTimezone, differsFromBrowser } = useReportTimezone();
</script>

<template>
  <p
    v-if="reportTimezone"
    class="text-xs leading-5 text-n-slate-11"
    data-testid="report-timezone-note"
  >
    {{ $t('REPORT.TIMEZONE_NOTE', { timezone: reportTimezone }) }}
    <span v-if="differsFromBrowser" data-testid="report-timezone-differs">
      {{ $t('REPORT.TIMEZONE_DIFFERS_FROM_BROWSER') }}
    </span>
  </p>
</template>
